export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
		},
	],
	singular_model_name_spanish: 'Pais',
	plural_model_name_spanish: 'Pais',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}